import React from "react";
import {
  Show,
  ShowButton,
  SimpleShowLayout,
  DateField,
  List,
  Datagrid,
  TextField,
  TextInput,
  Filter,
  EmailField,
  ReferenceField,
  ArrayField,
  SelectInput
} from "react-admin";
import { Grid, Typography, Divider } from "@mui/material";

// 상단 검색부분
const UserFilter = props => (
  <Filter {...props}>
    <TextInput resettable label="회원번호" source="member_no" alwaysOn />
    
    <SelectInput resettable
      label="타입" source="type" choices={[
        { id: 'google', name: 'google' },
        { id: 'kakao', name: 'kakao' },
        { id: 'fb', name: 'fb' }]} alwaysOn />
    

    <TextInput resettable label="이름" source="name" alwaysOn />
    <TextInput resettable label="지역1" source="address1" />
    <TextInput resettable label="지역2" source="address2" />
    <TextInput resettable label="지역3" source="address3" />
    <TextInput resettable label="이메일" source="email" />
  </Filter>
);

// 유저목록 리스트
export const UserList = props => (
  <List
    title="회원 관리"
    {...props}
    exporter={false}
    filters={<UserFilter />}
    bulkActionButtons={false}
    sort={{ field: "member_no", order: "DESC" }}
  >
    <Datagrid rowClick="show">
      <TextField label="회원번호" source="member_no" />
      <TextField label="연동계정" source="type" />
      <TextField label="이름" source="name" />
      <EmailField label="이메일" source="email" />
      <TextField label="레벨" source="level" />

      <ReferenceField
        label="목표대학"
        source="grade_id"
        reference="grade"
        linkType="show"
        sortable={false}
        allowEmpty
      >
        <TextField source="name" />
      </ReferenceField>

      <TextField label="포인트" source="mileage.mileage" />
      <TextField label="지역1" source="address1" />
      <TextField label="지역2" source="address2" />

      <DateField label="가입일" source="join_date" />
    </Datagrid>
  </List>
);

// ----------여기서부터 회원 상세보기 페이지-------------
const UserTitle = ({ record }) => {
  return <span>{record ? `"${record.name}"` : ""}님의 상세정보</span>;
};
const empty = ({ record }) => {
  return "";
};

export const UserShow = props => (          
      <Grid container spacing={2}>
        <Grid item xs={3} sm={3} className="grid-box">
          <Show title={<UserTitle />} {...props}>
            <SimpleShowLayout>
              <Typography variant="h5" gutterBottom>
                회원 기본 정보
              </Typography>
              <Divider />
              <TextField label="회원번호" source="member_no" />
              <DateField label="가입일" source="join_date" />
              <TextField label="이름" source="name" />
              <TextField label="연동계정" source="type" />
              <EmailField label="이메일" source="email" />
              <TextField label="레벨" source="level" />
            </SimpleShowLayout>
          </Show>
        </Grid>

        <Grid item xs={3} sm={3} className="grid-box">
          <Show title={<empty />} {...props}>
            <SimpleShowLayout>
              <Typography variant="h5" gutterBottom>
                지역
              </Typography>
              <Divider />
              <TextField label="지역1" source="address1" />
              <TextField label="지역2" source="address2" />
              <TextField label="지역3" source="address3" />
              <TextField label="지역4" source="address4" />
            </SimpleShowLayout>
          </Show>
        </Grid>

        <Grid item xs={3} className="grid-box">
          <Show title={<empty />} {...props}>
            <SimpleShowLayout>
              <Typography variant="h5" gutterBottom>
                회원 목표
              </Typography>
              <Divider />
              <TextField label="목표토익점수-LC" source="toeic_goal_lc" />
              <TextField label="목표토익점수-RC" source="toeic_goal_rc" />
              <ReferenceField
                label="목표대학"
                source="grade_id"
                reference="grade"
                linkType="show"
                sortable={false}
                allowEmpty
              >
                <TextField source="name" />
              </ReferenceField>
              <ReferenceField
                label="목표학과"
                source="major_id"
                reference="major"
                linkType="show"
                sortable={false}
                allowEmpty 
              >
                <TextField source="name" />
              </ReferenceField>
            </SimpleShowLayout>
          </Show>
        </Grid>

        <Grid item xm={3} className="grid-box">
          <Show title={<empty />} {...props}>
            <SimpleShowLayout>
              <Typography variant="h5" gutterBottom>
                투게더목록
              </Typography>
              <Divider />
              <ArrayField label="투게더 목록" source="togather_list">
                <Datagrid>
                  <TextField label="회원 번호" source="his_member_no" sortable={false}/>
                  <ReferenceField
                    label="이름"
                    source="his_member_no"
                    reference="user"
                    linkType="show"
                    sortable={false}
                  >
                    <TextField source="name" sortable={false}/>
                  </ReferenceField>
                </Datagrid>
              </ArrayField>
            </SimpleShowLayout>
          </Show>
        </Grid>


        <Grid item xm={3} className="grid-box">
          <Show title={<empty />} {...props}>
            <SimpleShowLayout>
              <Typography variant="h5" gutterBottom>
                제출 성적
              </Typography>
              <Divider />
              <ArrayField label="제출 성적" source="result_list">
                <Datagrid>
                  <TextField label="문제집" source="book_name" sortable={false}/>
                  <TextField label="답안" source="omr_name" sortable={false}/>
                  <TextField label="점수" source="point" sortable={false}/>
                  <TextField label="총점" source="totalPoint" sortable={false}/>
                  <TextField label="등급" source="rank" sortable={false} />
                  <ShowButton basePath={'/result'} resource={'result'}/>
                </Datagrid>
              </ArrayField>
            </SimpleShowLayout>
          </Show>
        </Grid>
      </Grid>
);
